import { attr } from '@ember-data/model';
import BaseFragment from '@square/dashboard-data/models/ember-data-base-fragment';
export default BaseFragment.extend({
  lineNumber: attr('number'),
  proratedAmount: attr('money-proto'),
  proratedTaxAmount: attr('money-proto')
});